import React from "react";
import {
    Box,
    Chip,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";

export default function TagSelectDropdown({
        selectedTagIds,
        availableTags,
        handleNewTagSelection,
        handleRemoveTag
    }) {

    return (
      <FormControl sx={{minWidth: "15rem", maxWidth: "15rem", m: 1}}>
          <InputLabel>Feedback</InputLabel>
          <Select
            multiple
            value={selectedTagIds}
            label="Feedback"
            onChange={handleNewTagSelection}
            renderValue={(selected) => (
              <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                  {
                      selected.map((id) => {
                          const tag = availableTags.find(tag => tag.id === id);
                          return (
                            <Chip
                              key={id}
                              label={tag ? tag.name : id}
                              onMouseDown={(event) => event.stopPropagation()}
                              onDelete={() => handleRemoveTag(id)}
                              size="small"/>
                          );
                      })
                  }
              </Box>
            )}>
              {
                  availableTags.map(tag => (<MenuItem key={tag.id} value={tag.id}>{tag.name}</MenuItem>))
              }
          </Select>
      </FormControl>
    );
};